// extracted by mini-css-extract-plugin
export default {"head":"head_head__QdQmR","title":"head_title__vDI0t","close":"head_close__IwMQk","timestamp":"head_timestamp__oaCaA","link":"head_link__oYG3f"};